import { useSelector, useDispatch } from 'react-redux'
import { pdfPageMetaSelector } from 'apps/studio/store/selectors/pdfPageMeta'
import {
  entriesSelector,
  sheetsSelector,
} from 'apps/formsCreationKit/store/selectors/entities'
import { activeEntryGuidSelector } from 'apps/formsCreationKit/store/selectors/settings'
import {
  pagesSelector,
  activePageSelector,
  visibleStyledElementsWorkspaceSelector,
  layoutsSelector,
} from 'apps/studio/store/selectors/pdf'
import {
  OutlineGroup,
  OutlineItem,
} from 'apps/studio/components/shared/Outline'
import { selectElement } from 'apps/studio/store/actions/sharedActions'
import { appSettingsActions } from 'apps/studio/store/reducers/settings/appSettings'
const { selectSheet } = appSettingsActions

export const PdfOutline = () => {
  const dispatch = useDispatch()
  const allPages = useSelector(pagesSelector)
  const pageMeta = useSelector(pdfPageMetaSelector)
  const elements = useSelector(visibleStyledElementsWorkspaceSelector)
  const entries = useSelector(entriesSelector)
  const sheets = useSelector(sheetsSelector)
  const activePage = useSelector(activePageSelector)
  const activeEntryGuid = useSelector(activeEntryGuidSelector)
  const layouts = useSelector(layoutsSelector)
  const activePageNumber = activePage?.page_number

  const pages = allPages.map(page => {
    const meta = pageMeta.find(m => m.pageNumber === page.page_number) || {}
    return {
      ...meta,
      ...page,
      pageNumber: page.page_number,
    }
  })

  // TODO: We might benefit from standardizing the panel markup into it's
  // own component now that we can see where the repeated markup occurs
  return (
    <div className="gcds--control-panel workspace-panel">
      <div className="panel--info is-sticky">
        <div className="panel--title">PDF Outline</div>
      </div>
      <div className="panel--content --workspace-panel--content">
        {pages.map(page => {
          const { id: pageId, pageNumber } = page
          const pageLayouts = layouts.filter(layout => layout.page_id === pageId)
          const topLevelLayout = pageLayouts.find(layout => !layout.parent_layout_id)
          const { id: sheetId } =
            sheets.find(sheet => sheet.section_id === topLevelLayout?.section_id) || {}
          const isActivePage =
            activePageNumber === pageNumber && !activeEntryGuid
          const pageElements = elements.filter(
            element => element.page_number === pageNumber
          )

          return (
            <OutlineGroup
              key={`page-${pageNumber}-outline`}
              title={`Page ${pageNumber}`}
              isActive={isActivePage}
              setIsActive={() => dispatch(selectSheet({ sheet_id: sheetId }))}
              type="page"
              pageNumber={pageNumber}
            >
              {pageElements.length &&
                pageElements.map(element => {
                  const { entry_guid, element_type } = element
                  const isActiveElement = activeEntryGuid === entry_guid
                  const entry = entries.find(entry => entry.guid === entry_guid)
                  const { label, sheet_id: entrySheetId } = entry
                  return (
                    <OutlineItem
                      key={`outline-element-${entry_guid}`}
                      type={element_type}
                      label={label}
                      isActive={isActiveElement}
                      setIsActive={() =>
                        dispatch(
                          selectElement({ entry_guid, sheet_id: entrySheetId })
                        )
                      }
                      pageNumber={pageNumber}
                    />
                  )
                })}
            </OutlineGroup>
          )
        })}
      </div>
    </div>
  )
}
